<div class=" scrollbar longtab">
    <div class="card pad15 pt-0">
        <form [formGroup]="addOccasionalShiftForm" (ngSubmit)="AddOccasionalShift()">
            <div class="mt-2 p-0">
                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xl-9">
                        <div class="row  ">
                            <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                                <label for="name" translate>lblOccasionName <span class="text-danger">*</span></label>
                                <div class="lbl-info">
                                    <input formControlName="occasionname" class="form-control mb-2" maxlength="30"
                                        [ngClass]="{'is-invalid': (cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors}"
                                        placeholder="Enter Occasion Name" [readonly]="isDisable">
                                    <div
                                        *ngIf="(cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors">
                                        <div *ngIf="cpf.occasionname.errors.required"
                                            class="help-block mt-1 text-danger" translate>
                                            lblOccasionNameRequired</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                                <label for="startDate" translate>lblStartDate<span class="text-danger">*</span>
                                </label>
                                <div class='date' *ngIf="!isDatesDisable">
                                    <input class="form-control datePicker width100force mb-2" appAfDatepicker
                                        [startDate]="'2011/01/01'" required [dateTime]="false"
                                        placeholder="{{ 'lblEnterStartDate' | translate }}"
                                        [disableNextMonthDates]="true" formControlName="startdate"
                                        [(ngModel)]="startdate" id="txtboxStartDate" type="text" value=""
                                        autocomplete="off">
                                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                                    <div *ngIf="(cpf.startdate.touched || cpf.startdate.dirty) && cpf.startdate.errors">
                                        <div *ngIf="cpf.startdate.errors.required" class="help-block mt-1 text-danger"
                                            translate>
                                            lblStartDateRequired</div>
                                    </div>
                                </div>
                                <div class="lbl-info" *ngIf="isDatesDisable">
                                    <input formControlName="startdate" class="form-control mb-2" maxlength="30"
                                        [(ngModel)]="startdate"
                                        [ngClass]="{'is-invalid': (cpf.startdate.touched || cpf.startdate.dirty) && cpf.startdate.errors}"
                                        [readonly]="true">
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                                <label for="endDate" translate>lblEndDate<span class="text-danger">*</span>
                                </label>
                                <div class='date' *ngIf="!isDatesDisable">
                                    <input class="form-control datePicker mb-2" appAfDatepicker
                                        [startDate]="'2011/01/01'" placeholder="{{ 'lblEnterEndDate' | translate }}"
                                        required [dateTime]="false" [disableNextMonthDates]="true"
                                        formControlName="enddate" [(ngModel)]="enddate" id="txtboxStartDate" type="text"
                                        value="" autocomplete="off">
                                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                                    <div *ngIf="(cpf.enddate.touched || cpf.enddate.dirty) && cpf.enddate.errors">
                                        <div *ngIf="cpf.enddate.errors.required" class="help-block mt-1 text-danger"
                                            translate>
                                            lblEndDateRequired</div>
                                    </div>
                                </div>
                                <div class="lbl-info" *ngIf="isDatesDisable">
                                    <input formControlName="enddate" class="form-control mb-2" maxlength="30"
                                        [(ngModel)]="enddate"
                                        [ngClass]="{'is-invalid': (cpf.enddate.touched || cpf.enddate.dirty) && cpf.enddate.errors}"
                                        [readonly]="true">
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-6 col-lg-6 col-xl-3 af-form-group pt-20">
                        <button type="submit" class="btn btn-primary mb-2" [disabled]="!addOccasionalShiftForm.valid"
                            aria-label="Center Align" translate>lblSave</button>
                        <button type="button" class="btn btn-primary ml-2 mb-2" aria-label="Center Align"
                            (click)="OnClear()" translate>lblAddOccasion</button>
                        <button type="button" class="btn btn-primary ml-2 mb-2" [hidden]="!isDelete"
                            aria-label="Center Align" (click)="OnDelete()" translate>lblDelete</button>
                    </div>

                </div>
            </div>
        </form>
        <div class="p-0">
            <div class="row">
                <div class="col-md-6 col-lg-6 col-xl-3 af-form-group" *ngFor="let itm of OccasionList">
                    <label class="mr10"><input name="options" ng-control="options" type="radio" [value]="itm.rowId"
                            (change)="ChangeOccasion()" [(ngModel)]="SelectedRadioButton"> {{itm.occasionName}}</label>
                </div>
            </div>
        </div>
        <div class="table-responsive tableMx-15 form-check pl-0" *ngIf="SelectedRadioButton > 0">


            <table class="tablest1">
                <thead>
                    <tr>
                        <th style="width: 10%" class="text-center" scope="col" translate>lblIsWorking</th>
                        <th style="width: 30%" scope="col" translate>lblDay</th>
                        <th style="width: 30%" scope="col" translate>lblSlotFrom</th>
                        <th style="width: 30%" scope="col" translate>lblSlotTill</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container>
                        <tr *ngFor="let workingHours of userWorkingHours; let i = index">
                            <td class="text-center">
                                <div class="custom-checkbox">
                                    <input type="checkbox" [(ngModel)]="workingHours.open" [value]="true"
                                        [checked]="workingHours.open" [id]="i" />
                                </div>
                            </td>
                            <td>{{workingHours.day}}</td>
                            <td>
                                <div class="date iconfix">
                                    <ngb-timepicker [(ngModel)]="workingHours.openingTime"
                                        [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onChangeOpeningHours(i,$event)"></ngb-timepicker>
                                </div>
                            </td>
                            <td>
                                <div class="date iconfix">
                                    <ngb-timepicker [(ngModel)]="workingHours.closingTime"
                                        [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onChangeClosingHours(i,$event)"></ngb-timepicker>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="mb15">
            <div class="card-header" translate>lblBreakTimings</div>
            <div class="pad15 pt-0">
                <div class="table-responsive tableMx-15">
                    <table class="tablest1" aria-describedby="LunchTimings">
                        <thead>
                            <tr>
                                <th style="width:40%" scope="col" translate>lblName </th>
                                <th style="width:30%" scope="col" translate>lblStartTime </th>
                                <th style="width:30%" scope="col" translate>lblEndTime </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container>
                                <tr>
                                    <td>
                                        <div class="date iconfix">
                                            <span translate>lblLunchBreak</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.lunchStartTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getstartHours($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.lunchEndTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getendHours($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="date iconfix">
                                            <span translate>lblBreak1</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.break1StartTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getstartHoursBreak1($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.break1EndTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getendHoursBreak1($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="date iconfix">
                                            <span translate>lblBreak2</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.break2StartTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getstartHoursBreak2($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="date iconfix">
                                            <ngb-timepicker [(ngModel)]="lunchShift.break2EndTime"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="getendHoursBreak2($event, lunchShift)"></ngb-timepicker>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
            <button class="btn btn-primary btn-lg" (click)="onSaveChanges(false)" aria-label="Center Align"
                translate>lblSaveChanges</button>
            <button class="btn btn-primary ml-2 btn-lg" (click)="onSaveChanges(true)" aria-label="Center Align"
                translate>lblSaveAndClose</button>
            <a (click)="OnClose()" class="btn btn-secondary ml-2 btn-lg" translate>lblCancel</a>
        </div>
    </div>
</div>